import { type ReactElement } from 'react';
import { Button as ReactAriaButton, type ButtonProps } from 'react-aria-components';

export function MenuButton(props: ButtonProps): ReactElement {
  return <ReactAriaButton {...props} />;
}
